// extracted by mini-css-extract-plugin
export default {"w-full":"Switch_w-full__KnDnM","switch":"Switch_switch__bqVNZ","input":"Switch_input__vIsIE","inner":"Switch_inner__hbbfE","box":"Switch_box__HBxlB"};